import { render, staticRenderFns } from "./TransactionsViewTable.vue?vue&type=template&id=026386c9&lang=pug&"
import script from "./TransactionsViewTable.vue?vue&type=script&lang=js&"
export * from "./TransactionsViewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports